// import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';

import { MaterialUIControllerProvider } from "context";
import { NotificationProvider } from "context/NotificationContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);